export function Avatar({ src, name, className = "h-9 w-9", testid }) {
  const initial = (name || "?").charAt(0).toUpperCase();
  if (src) {
    return (
      <img
        src={src}
        alt={name}
        data-testid={testid}
        className={`${className} rounded-full object-cover bg-secondary shrink-0`}
      />
    );
  }
  return (
    <div
      data-testid={testid}
      className={`${className} rounded-full bg-secondary flex items-center justify-center font-heading font-semibold shrink-0`}
    >
      {initial}
    </div>
  );
}
